export default __webpack_public_path__ + "static/media/whiteEdit.86999b8e.svg";